<template src="./formulas.html">

</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'
import { genericFunction } from '@/commons.js'

export default {
  name: "Formulas",
  data() {
    return {
      alertMsg: '',
      current_id: null,
      currentPage: 1,
      formData: {},
      id2Delete: null,
      formulas: [],
      paginatedFormulas: [], 
      selectedFormula: {},
      showAlert: false,
      showModal: false,
      totalPages: 1,
      totalRows: 0,
      perPage: 10,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        this.updatePaginatedFormulas()
      }
    },
    perPage: {
      handler(){
      
        this.currentPage = 1
        this.updatePaginatedFormulas()
      }
    },
  },   
  async mounted() {

    await this.loadFormulas()
    this.updatePaginatedFormulas()
  },
  methods: {
    cancelFormula() {

      this.current_id = null
      this.selectedFormula = {}
    },
    deleteRecord(id) {

      this.id2Delete = id
      this.showModal = true
    },
    editRow(formula) {
      
      this.selectedFormula = { ...formula }
      this.current_id = formula.id
    },
    genericFunction,     
    handleCancel() {

      this.id2Delete = null
    },
    async handleDelete() {

      try {

        const url = API_URL + "price_list/CalculationFormulasDetail/"+this.id2Delete+"/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const response = await axios.delete(url, {headers})
        this.showModal = false
        this.current_id = null
        await this.loadFormulas()
      }
      catch(error) {

        if(error.response.status == 500) {
        
          this.alertMsg = "Attenzione! Il tipo di merce risulta essere utilizzato da almeno una riga di listino. Per rimuoverlo di devono prima rimuovere tutte le righe di listino che utilizzano questo tipo di merce"
          this.showAlert = true
        }
      }
    },
    async insertFormula() {

      if(this.selectedFormula.formula) {

        const url = API_URL + "price_list/CalculationFormulasDetail/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        await axios.post(url, this.selectedFormula, {headers})
        await this.loadFormulas()
        await this.updatePaginatedFormulas()
        this.selectedFormula = {}
      }
    },
    async loadFormulas() {

      this.formulas = await this.genericFunction('fetchFormulas')() || []
      await this.updatePaginatedFormulas()
      this.totalRows = this.formulas.length
      this.totalPages = Math.ceil(this.totalRows / this.perPage)
    },
    async onPageChange(page) {

      this.currentPage = page
    },
    async updateFormula() {

      const url = API_URL + "price_list/CalculationFormulasDetail/" + this.current_id + "/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      await axios.patch(url, this.selectedFormula, {axios})
      await this.loadFormulas()
      await this.updatePaginatedFormulas()
      this.selectedFormula = {}
      this.current_id = null
    },
    updatePaginatedFormulas() {

      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      this.paginatedFormulas = this.formulas.slice(start, end)
    },
  },
}

</script>

<style scoped>

::v-deep(.form-check-input) {
  transform: scale(2); /* Adjust the scale factor as needed */
}

.row-selection:hover {
  background-color: lightgray;
}

</style>